
import React from 'react';
 
 

 

import KeeVue from '../base/KeeVue.js'
 
 

import $ from 'jquery';



 

export default class FsList extends KeeVue {
  constructor(props) {
         super(props);

			this.state =  {
				gridParentId: this.getRandString(),
				floatItem: null,
				longPressItem: null,
				needSaveSort: false,
				floatItemStyle: {
					left_yuan: 0,
					top_yuan: 0,
					left: 0,
					top: 0,
					"z-index": 100,
				},
				line1px: {
					'position': 'absolute',
					'left': 0,
					'right': 0,
					'top': 0,
					'border-top': '1px solid #D9D9D9',
					'height': "1px",
					'transform-origin': '0 0',
					'-webkit-transform': 'scaleY( ' + (1 / window.devicePixelRatio) + ')',
					'transform': 'scaleY( ' + (1 / window.devicePixelRatio) + ' )'
				},
				line1pxleft: {
					'top': 0,
					'left': 0,
					'bottom': 0,
					'position': 'absolute',
					'border-right': '1px solid #D9D9D9',
					'width': "1px",
					'transform-origin': '0 0',
					'-webkit-transform': 'scaleX( ' + (1 / window.devicePixelRatio) + ')',
					'transform': 'scaleX( ' + (1 / window.devicePixelRatio) + ' )'
				},
				line1pxright: {
					'top': 0,
					'right': 0,
					'bottom': 0,
					'position': 'absolute',
					'border-right': '1px solid #D9D9D9',
					'width': "1px",
					'transform-origin': '100% 100%',
					'-webkit-transform': 'scaleX( ' + (1 / window.devicePixelRatio) + ')',
					'transform': 'scaleX( ' + (1 / window.devicePixelRatio) + ' )'
				},
				line1pxbottom: {
					'left': 0,
					'right': 0,
					'bottom': 0,
					'position': 'absolute',
					'border-bottom': '1px solid #D9D9D9',
					'height': "1px",
					'transform-origin': '100% 100%',
					'-webkit-transform': 'scaleY( ' + (1 / window.devicePixelRatio) + ')',
					'transform': 'scaleY( ' + (1 / window.devicePixelRatio) + ' )'
				}
			}
		
}

componentDidMount(){
			// this.onEvent("kee-touch-start", this.touchStart);
			// this.onEvent("kee-touch-move", this.touchMove);
			// this.onEvent("kee-touch-end", this.touchEnd);
			// this.onEvent("select", this.onSelect);
			// this.onEvent("kee-long-press", this.onLongPress);
		}

			touchStart=(targetId)=> {
				if(this.props.list)
				{
					for(var i = 0; i < this.list.length; i++) {
						if(this.list[i].id === targetId) {
							this.list[i].select = true;
						} else {
							this.list[i].select = false;
						}
					}
				}
				
			} 
			touchMove=(zuobiao)=> {} 
			touchEnd=(item)=> {
				this.state.floatItem = null;
				if(this.state.needSaveSort === true) {
					this.$emit("sort");
					this.state.needSaveSort = false;
				}
			} 
			onSelect=(targetId)=> {} 
			onLongPress=(targetId)=> {}
		
  render(){
  return(
  
<div className={`kee-fs-list`} >
   
               
				
				{
					this.props.list?
					this.props.list.map((item,index)=>{
						
						return  <div id={item.id} tid={item.id} key={item.id} pagenode={item.id} className={`kee-fs-list`} style={{textAlign:'left'}} >
						<div style={{padingTop:'5px'}}>
						{(this.props.renderItem?this.props.renderItem(item,index):'')}
						</div>
						</div>
				 
					}):''
				}
                
          
</div>
  );}
 }
  
